// extracted by mini-css-extract-plugin
module.exports = {"page":"AccessPage_page__10433","tabs":"AccessPage_tabs__3TZeh","nestedTabs":"AccessPage_nestedTabs__1Jrio","header":"AccessPage_header__2pg-V","body":"AccessPage_body__2kOt7"};